import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MgService } from 'src/app/services/mg.service';
import { Call } from 'src/app/models/call.model';
import { Pagination } from 'src/app/models/pagination.model';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-list-calls',
  templateUrl: './list-calls.component.html',
  styleUrls: ['./list-calls.component.scss']
})
export class ListCallsComponent implements OnInit {
  public page: Pagination;
  public calls: Call[];
  public isLoading: boolean = false;

  public pageSize = 0;
  public length = 0;
  public pageSizeOptions: number[] = [1, 5, 10, 25, 100, 200, 300];
  public pageEvent: PageEvent;

  public statusCurrent: string;
  public filter: any;

  public statuses: any = {
    'A': { name: 'Abertos', value: 'A' },
    'T': { name: 'Em Atendimento', value: 'T' },
    'P': { name: 'Pendente', value: 'P' },
    'R': { name: 'Resolvido', value: 'R' },
    'F': { name: 'Fechado', value: 'F' },
    'C': { name: 'Cancelado', value: 'C' }
  }

  public statusSelection: any[] = [
    { name: 'Abertos', value: 'A' },
    { name: 'Em Atendimento', value: 'T' },
    { name: 'Pendente', value: 'P' }
  ];

  public statusExclusion: any[] = [];
  public businesses: number[] = null;
  public businessUsers: number[] = null;
  public operators: number[] = null;
  public range: any = null;
  public text: string = null;

  constructor(
    private api: MgService,
    private router: Router,
    private activedRouter: ActivatedRoute
  ) { }

  ngOnInit(): void {
    let routerQueryStatus = this.activedRouter.snapshot.queryParams.statuses;
    let businesses = this.activedRouter.snapshot.queryParams.businesses;
    let businessUsers = this.activedRouter.snapshot.queryParams.businessUsers;

    if (businesses) {
      this.businesses = businesses;
    }

    if (businessUsers) {
      this.businessUsers = businessUsers;
    }

    if (routerQueryStatus) {
      this.statusSelection = [
        {
          name: this.statuses[routerQueryStatus].name,
          value: this.statuses[routerQueryStatus].value
        }
      ];
    }

    this.listCalls();
  }

  public set setPage(page: PageEvent) {
    this.pageEvent = page;
    this.listCalls(page.pageIndex + 1, page.pageSize);
  }

  private listCalls(page: number = 1, perPage: number = 10): void {
    this.isLoading = true;
    this.api.listCalls(
      page,
      perPage,
      this.getStatusSelection,
      this.statusExclusion,
      this.businesses,
      this.businessUsers,
      this.operators,
      this.range,
      this.text
    )
      .subscribe(
        res => {
          this.page = res;
          this.calls = this.page.data;
          this.length = this.page.meta.total
          this.pageSize = this.page.meta.per_page
        },
        err => {
          console.error(err);
          this.isLoading = false;
        },
        () => this.isLoading = false,
      )
  }

  public search(filter) {
    if (filter.business) {
      this.businesses = [filter.business];
    } else {
      this.businesses = [];
    }

    if (filter.businessUser) {
      this.businessUsers = [filter.businessUser];
    } else {
      this.businessUsers = [];
    }

    if (filter.operator) {
      this.operators = [filter.operator]
    } else {
      this.operators = [];
    }

    if (filter.text) {
      this.text = filter.text
    } else {
      this.text = null
    }

    if (filter.range.start && filter.range.end) {
      this.range = {
        start: filter.range.start.format("YYYY-MM-DD"),
        end: filter.range.end.format("YYYY-MM-DD"),
      }
    } else {
      this.range = null;
    }

    this.listCalls();
  }

  public goToAddCall(): void {
    this.router.navigate(['/operador/chamados/criar'])
  }

  public removeStatus(status) {
    this.statusSelection = this.statusSelection.filter(item => item != status);
    this.listCalls();
  }

  public addStatusToSelection(value) {
    if (!value) return
    this.statusSelection = [
      ...this.statusSelection,
      {
        name: this.statuses[value].name,
        value: this.statuses[value].value
      }
    ];
    this.listCalls();
  }

  public get getStatusSelection(): any[] {
    let status = this.statusSelection.map(status => status.value);
    return status;
  }
}
